import { ReactElement, useEffect, useState } from 'react'

interface TransitionOutProps {
  isVisible: boolean
  visibleOnLoad?: boolean
  outDelay?: number
  children: ReactElement
}

const TransitionOut = ({ isVisible, visibleOnLoad = false, outDelay = 0, children }: TransitionOutProps) => {
  const [returnChildren, setReturnChildren] = useState(visibleOnLoad)

  useEffect(() => {
    if (isVisible) return setReturnChildren(true)

    const timeout = setTimeout(() => {
      setReturnChildren(false)
    }, outDelay)

    return () => clearTimeout(timeout)
  }, [isVisible, outDelay])

  if (!returnChildren) return null

  return children
}

export default TransitionOut
